var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogotypePrejoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1348 22H49.8195C49.1518 16.4749 46.6535 11.298 42.6778 7.32233C37.9894 2.63392 31.6305 0 25.0001 0C18.3697 0 12.0108 2.63392 7.32244 7.32233C3.34673 11.298 0.848364 16.4749 0.180664 22H12.8654C13.4074 19.8081 14.5381 17.7844 16.1613 16.1612C18.5055 13.817 21.6849 12.5 25.0001 12.5C28.3153 12.5 31.4947 13.817 33.8389 16.1612C35.4622 17.7844 36.5928 19.8081 37.1348 22Z",
    fill: "url(#paint0_linear_134_7563)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8654 28H0.180664C0.848364 33.5251 3.34673 38.702 7.32243 42.6777C12.0108 47.3661 18.3697 50 25.0001 50C31.6305 50 37.9894 47.3661 42.6778 42.6777C46.6535 38.702 49.1518 33.5251 49.8195 28H37.1348C36.5928 30.1919 35.4622 32.2156 33.8389 33.8388C31.4947 36.183 28.3153 37.5 25.0001 37.5C21.6849 37.5 18.5055 36.183 16.1613 33.8388C14.5381 32.2156 13.4074 30.1919 12.8654 28Z",
    fill: "url(#paint1_linear_134_7563)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_134_7563",
    x1: 39.7433,
    y1: 0.00000182311,
    x2: 19.2952,
    y2: 25.6411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#816ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_134_7563",
    x1: 39.7433,
    y1: 28,
    x2: 19.2952,
    y2: 53.6411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#816ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotypePrejoin);
export default __webpack_public_path__ + "static/media/logotype-prejoin.9745f44104f49b3faa9e77443865b9b9.svg";
export { ForwardRef as ReactComponent };